import { render, staticRenderFns } from "./Richieste.vue?vue&type=template&id=d30fe2c2&"
import script from "./Richieste.vue?vue&type=script&lang=js&"
export * from "./Richieste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports